import Tooltip from '@mui/material/Tooltip';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import { useDashboardTheme } from '../utils';

function InfoTooltip({ text }) {
  const t = useDashboardTheme();
  if (!text) return null;
  return (
    <Tooltip
      title={text}
      placement='top'
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 280,
            fontSize: '0.72rem',
            lineHeight: 1.5,
            px: 1.5,
            py: 1,
            borderRadius: '8px',
            background: t.isDark ? '#1e293b' : '#1e293b',
            color: '#e2e8f0'
          }
        },
        arrow: { sx: { color: '#1e293b' } }
      }}
    >
      <MDBox
        component='span'
        display='inline-flex'
        alignItems='center'
        sx={{ cursor: 'help', ml: 0.5, verticalAlign: 'middle', lineHeight: 1 }}
      >
        <Icon sx={{ fontSize: '0.85rem !important', color: t.secondaryText, opacity: 0.5, '&:hover': { opacity: 0.85 } }}>info_outline</Icon>
      </MDBox>
    </Tooltip>
  );
}

export default InfoTooltip;
